<ng-container *transloco="let t">
  @if (loading()) {
    <app-loading></app-loading>
  } @else if (!loading() && data && !error) {
    <div class="container no-container-on-mobile mb-0">
      <!-- Page header -->
      <div class="header">
        <div class="mb-3 cover-image"
          [ngStyle]="{ 'background-image': '/*linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.1) 30%, rgba(0, 0, 0, 0.6) 70%, rgba(0, 0, 0, 0.9) 100%),*/ url(' + data.image + ')', 'background-color': data.pwa_bg_color }">
          <!-- <figure style="width:100%; margin:0; text-align: center;padding-top: 50px;">
                <img [src]="data.logo" width="150" height="150" [alt]="t('company_logo')">
              </figure> -->
          <!-- <img [src]="data.image" alt="Header"> -->
          @if (data.mostra_denominazione) {
            <div class="header-title flex justify-content-center align-items-center h-full">
              <h1 class="mb-0" [ngStyle]="{color: data.pwa_title_color || 'white' }">{{ data.title }}</h1>
            </div>
          }
        </div>
      </div>
    
      <!-- Contact CTA -->
      <div class="flex cta">
        <div class="m-auto">
          <a class="flex align-items-center no-underline text-color" href="tel:{{ data.telephone }}" target="_blank"
            (click)="insightService.send({event: 'click', event_name: 'click_phone'})" aria-label="Chiamaci">
            <span class="material-icons text-primary" aria-hidden="true">
              call
            </span>
            <span class="ml-1">{{ t('cta.call') }}</span>
          </a>
        </div>
        @if ((data.whatsapp && !data.telegram) || (data.telegram && !data.whatsapp)) {
          <div class="m-auto">
            <a class="flex align-items-center no-underline text-color"
              [href]="(data.telegram ? 'https://t.me/' + data.telegram.split('@').join('') : 'https://wa.me/' + data.whatsapp)"
              target="_blank"
              (click)="insightService.send({event: 'click', event_name: data.telegram ? 'chat_telegram' : 'chat_whatsapp'})"
              aria-label="Chatta con noi">
              <span class="material-icons text-primary" aria-hidden="true">
                chat
              </span>
              <span class="ml-1">{{ t('cta.chat') }}</span>
            </a>
          </div>
        }
        @if (data.whatsapp && data.telegram) {
          <div class="m-auto">
          <p class="mt-0 mb-0 cursor-pointer flex align-items-center no-underline text-color"
            (click)="chatModalVisible.set(true)" aria-label="Chatta su Telegram">
            <span class="material-icons text-primary" aria-hidden="true">
              chat
            </span>
            <span class="ml-1">{{ t('cta.chat') }}</span>
          </p>
        </div>
        }
        @if (!data.email?.includes('privaterelay.appleid.com')) {
          <div class="m-auto">
          <a class="flex align-items-center no-underline text-color" target="_blank" href="mailto:{{ data.email }}"
            (click)="insightService.send({event: 'click', event_name: 'click_mail'})" aria-label="Contattaci per email">
            <span class="material-icons text-primary" aria-hidden="true">
              email
            </span>
            <span class="ml-1">{{ t('cta.email') }}</span>
          </a>
        </div>
        }
        <div class="m-auto">
          <a class="flex align-items-center no-underline text-color" target="_blank"
            href="http://maps.google.com/?q={{ data.address }}"
            (click)="insightService.send({event: 'click', event_name: 'click_map'})">
            <span class="material-icons text-primary" aria-hidden="true">
              place
            </span>
            <span class="ml-1" aria-label="Apri mappa">{{ t('cta.map') }}</span>
          </a>
        </div>
      </div>
      <p-divider styleClass="mt-3 mb-2"></p-divider>
    </div>
    
    <div class="container mt-0">
      <!-- Company description -->
      @if (data.description) {
        <div>
          <p class="mb-1 mt-1" [innerHTML]="data.description | translate"></p>
          <p-divider styleClass="mt-4 mb-3"></p-divider>
        </div>
      }
    
      <!-- Offers -->
      <h2 class="text-center">{{ t('our_offers') }}</h2>
    
      @if (data.offers.length == 0) {
        <div class="text-center">
          <p>{{ t('no_offers_available') }}</p>
        </div>
      }
    
      @if (data.offers.length != 0) {
        <div class="grid">
          @for (offer of data.offers?.slice(0, 4); track offer) {
            <div class="col-12 md:col-6 lg:col-4">
              <app-offer-card [id]="generateOfferUrl(offer)" [title]="offer.titolo | translate" [image]="offer.images?.[0]?.path || offer.foto"
                [expirationDate]="offer.scadenza"></app-offer-card>
            </div>
          }
        </div>
    
        <div class="text-center mt-2">
          <p-button (onClick)="router.navigate(['/proposte'])" [label]="t('all_offers') | uppercase"></p-button>
        </div>
      }
    
      <!-- Register -->
      @if (data.referral && ! data.banner_url) {
        <div class="mt-3 w-full border-1 border-solid border-200 p-4 border-round">
          <h2 class="text-center mt-0">{{ t('create_pwa') }}</h2>
          <div class="flex justify-content-center mt-3">
            <p-button [label]="t('register')" (onClick)="openRegisterLink(data.referral)"></p-button>
          </div>
        </div>
      }
    
      @if (data.referral && data.banner_url) {
        <div class="mt-5 mb-2 w-full">
          <a href="{{data.referral}}" target="_blank">
            <figure class="m-0 p-0">
              <img class="w-full" alt="banner-register" [src]="data.banner_url">
            </figure>
          </a>
        </div>
      }
    
      <!-- Opening hours -->
      <h2 class="text-center">{{ t('hours') }}</h2>
      <p-divider align="center">
        <span class="material-icons-outlined" aria-hidden="true" role="separator">
          schedule
        </span>
      </p-divider>
    
      <app-opening-hours [openingHours]="openingHours"></app-opening-hours>
    
      <!-- Company notes -->
      @if (data.notes) {
        <div>
          <p class="mb-1 mt-4" [innerHTML]="data.notes | translate | safeStyle"></p>
          <p-divider styleClass="mt-4 mb-3"></p-divider>
        </div>
      }
    
      <div class="flex justify-content-center">
        <p-button class="ml-2 mt-3" [label]="t('other_locations')" (onClick)="router.navigate(['/sedi'])"></p-button>
      </div>
    
      @if (socials) {
        <ul class="list-none p-0 mt-3 social-buttons flex flex-wrap text-center justify-content-center">
          @if (socials['Facebook']) {
            <li>
            <a class="mt-3 share-button facebook no-underline" target="_blank" [href]="socials['Facebook']"
              title="Condividi su facebook">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path fill="#ffffff"
                  d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
              </svg>
            </a>
          </li>
          }
          @if (socials['Twitter']) {
            <li>
            <a class="mt-3 share-button twitter no-underline" target="_blank" [href]="socials['Twitter']"
              title="Condividi su X">
              <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd"
                clip-rule="evenodd" viewBox="0 0 512 462.799">
                <path fill="#fff" fill-rule="nonzero"
                  d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z" />
              </svg>
            </a>
          </li>
          }
          @if (socials['Instagram']) {
            <li>
            <a class="mt-3 share-button instagram no-underline" target="_blank" [href]="socials['Instagram']"
              title="Condividi su Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="Instagram">
                <path
                  d="M11 0H5a5 5 0 0 0-5 5v6a5 5 0 0 0 5 5h6a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zm3.5 11c0 1.93-1.57 3.5-3.5 3.5H5c-1.93 0-3.5-1.57-3.5-3.5V5c0-1.93 1.57-3.5 3.5-3.5h6c1.93 0 3.5 1.57 3.5 3.5v6z"
                  fill="#ffffff" class="color000000 svgShape"></path>
                <path
                  d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 6.5A2.503 2.503 0 0 1 5.5 8c0-1.379 1.122-2.5 2.5-2.5s2.5 1.121 2.5 2.5c0 1.378-1.122 2.5-2.5 2.5z"
                  fill="#ffffff" class="color000000 svgShape"></path>
                <circle cx="12.3" cy="3.7" r=".533" fill="#ffffff" class="color000000 svgShape"></circle>
              </svg>
            </a>
          </li>
          }
          @if (shareEnabled) {
            <li>
            <a tabindex="0" (keyup.enter)="share()" (click)="share()" class="mt-3 share-button share no-underline"
              title="Condividi">
              <img src="share.png" alt="Share" draggable="false" width="25" height="25">
            </a>
          </li>
          }
        </ul>
      }
    </div>

    <!-- Chat modal -->
    <p-dialog [showHeader]="false" [visible]="chatModalVisible()"
      [breakpoints]="{ '960px': '65vw' }" [style]="{ width: '40vw' }" [modal]="true" [draggable]="false"
      [resizable]="false">
      <div class="text-center mt-3">
        <img [src]="data.logo" [alt]="t('company_logo')" width="80">
        <h3 class="mb-1">{{ t('chat_modal.title', {name: data.denominazione}) }}</h3>
        <p class="mb-2 mt-0">{{ t('chat_modal.text', {name: data.denominazione }) }}</p>
      </div>
      <div class="mt-4 flex flex-wrap justify-content-around">
        <a (click)="insightService.send({event: 'click', event_name: 'click_chat_telegram'})" target="_blank"
          [href]="'https://t.me/' + data.telegram?.split('@')?.join('')" class="no-underline text-color">
          <div class="flex flex-column align-items-center justify-content-center">
            <img src="telegram.png" [alt]="t('cta.telegram_alt_img')" width="50">
            <span class="text-muted mt-2">{{ t('cta.telegram') }}</span>
          </div>
        </a>
        <a (click)="insightService.send({event: 'click', event_name: 'click_chat_whatsapp'})" target="_blank"
          [href]="'https://wa.me/' + data.whatsapp" class="no-underline text-color">
          <div class="flex flex-column align-items-center justify-content-center">
            <img src="whatsapp.png" [alt]="t('cta.whatsapp_alt_img')" width="50">
            <span class="text-muted mt-2">{{ t('cta.whatsapp') }}</span>
          </div>
        </a>
      </div>
      <div class="flex flex-row justify-content-end align-items-center mt-5">
        <p-button [label]="t('close')" severity="secondary" (onClick)="chatModalVisible.set(false)"></p-button>
      </div>
    </p-dialog>
  }

  <!-- Open installed App -->
  <p-dialog [header]="t('installed_app_modal.title')" [visible]="installedAppModal().visible"
    [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '50vw' }" [modal]="true" [draggable]="false"
    [resizable]="false" [closable]="false">
    <div class="text-center mb-0 mt-0">
      <p class="mb-2 mt-0">{{ t('installed_app_modal.text') }}</p>
      <div class="mt-5 flex justify-content-end flex-row">
        <p-button [label]="t('open')" [loading]="downloadModal().loading" (onClick)="openInstalledApp()"></p-button>
        <p-button class="ml-2" [label]="t('close')" severity="secondary" [loading]="downloadModal().loading"
          (onClick)="installedAppModal.set({ visible: false, url: null })"></p-button>
      </div>
    </div>
  </p-dialog>

  <!-- Download PWA modal -->
  <p-dialog [showHeader]="false" [visible]="downloadModal().visible" [breakpoints]="{ '425px': '90vw', '960px': '80vw' }"
    [style]="{ width: '40vw' }" [modal]="true" [draggable]="false" [resizable]="false" [ngStyle]="{'z-index': '99999999', 'position': 'absolute'}">
    <div class="flex justify-content-end">
      <span (click)="dimissDownloadModal()" class="material-icons-outlined cursor-pointer mt-3">
        close
      </span>
    </div>
    <div class="text-center">
      <h3 class="mb-3 mt-3">{{ t('download_app_modal.title') }}</h3>
    </div>
    @if (downloadModal().error || downloadModal().message) {
      <p-message
        [severity]="downloadModal().error ? 'error' : 'warn'" [text]="downloadModal().error || downloadModal().message"></p-message>
    }
    @if (downloadModal().os == 'Android') {
      <div class="mt-3 flex justify-content-center align-items-center flex-column">
      <div class="text-center">
        <p class="mb-3 mt-0">{{ t('download_app_modal.text') }}</p>
      </div>
      <p-button [label]="t('download_app_modal.add_home')" [loading]="downloadModal().loading"
        (onClick)="downloadApp()"></p-button>
      <!-- <p-button class="ml-2 mt-3" [label]="t('download_app_modal.maybe_later')" (onClick)="dimissDownloadModal()"></p-button> -->
    </div>
    }
    @if (downloadModal().os == 'iOS') {
      <div class="mt-1">
      <!-- <p class="mb-0 mt-0" [innerHTML]="sanitizer.bypassSecurityTrustHtml(t('download_app_modal.ios_istructions'))"></p>
      <div class="mt-1 flex justify-content-center align-items-center">
        <p-button class="ml-2 mt-3" [label]="t('ok')" (onClick)="dimissDownloadModal()"></p-button>
      </div> -->
      <div class="w-full flex justify-content-center mt-2">
        <iframe width="220" height="480" src="https://youtube.com/embed/xAkemjOKf64?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&loop=1&playlist=xAkemjOKf64" referrerPolicy="origin" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
    }
  </p-dialog>

  <!-- New offers modal -->
  <p-dialog [header]="t('new_offers_modal.title')" [visible]="newOffersModal().visible"
    [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '50vw' }" [modal]="true" [draggable]="false"
    [resizable]="false" [closable]="false">
    <div class="text-center mt-0">
      @if (newOffersModal().newOffers.length == 1) {
        <p class="mb-2 mt-0">{{ t('new_offers_modal.text_single') }}</p>
      }
      @if (newOffersModal().newOffers.length != 1) {
        <p class="mb-2 mt-0">{{ t('new_offers_modal.text_multiple', {number:
          newOffersModal().newOffers.length}) }}</p>
      }
    </div>
    <div class="mt-1">
      <div class="mt-5 flex justify-content-end flex-row">
        <p-button [label]="t('show_offers')" [loading]="newOffersModal().loading"
          (onClick)="router.navigate(['/proposte'])"></p-button>
        <p-button class="ml-2" [label]="t('close')" severity="secondary" [loading]="downloadModal().loading"
          (onClick)="newOffersModal.set({ ...newOffersModal(), visible: false })"></p-button>
      </div>
    </div>
  </p-dialog>
</ng-container>